export default __webpack_public_path__ + "static/media/17.bc202c60.png";